"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthTokenErrorHandleService = void 0;
const jsonwebtoken_1 = require("jsonwebtoken");
const AuthTokenExpiredError_1 = require("../../Error/AuthTokenExpiredError");
const AuthTokenNotBeforeError_1 = require("../../Error/AuthTokenNotBeforeError");
const AuthTokenVerifyError_1 = require("../../Error/AuthTokenVerifyError");
const UnexpectedError_1 = require("../../Error/UnexpectedError");
class AuthTokenErrorHandleService {
    static generateError(tokenVerifyError) {
        if (tokenVerifyError instanceof jsonwebtoken_1.TokenExpiredError) {
            return new AuthTokenExpiredError_1.AuthTokenExpiredError(tokenVerifyError);
        }
        if (tokenVerifyError instanceof jsonwebtoken_1.NotBeforeError) {
            return new AuthTokenNotBeforeError_1.AuthTokenNotBeforeError(tokenVerifyError);
        }
        if (tokenVerifyError instanceof jsonwebtoken_1.JsonWebTokenError) {
            return new AuthTokenVerifyError_1.AuthTokenVerifyError(tokenVerifyError);
        }
        return new UnexpectedError_1.UnexpectedError(tokenVerifyError);
    }
}
exports.AuthTokenErrorHandleService = AuthTokenErrorHandleService;
//# sourceMappingURL=AuthTokenErrorHandleService.js.map